// Core
import { handleActions } from 'redux-actions';
import { Map, List } from 'immutable';

// Instruments
import { historyActions as actions } from './actions';

const initialState = Map({
    hotels: Map(),
});

export const historyReducer = handleActions({
    [actions.addViewedHotelSuccess]: (state, { payload: { hotelId, offerId }}) => {
        return state.setIn(['hotels', hotelId], { hotelId, offerId });
    },
    [actions.loadViewedHotelsSuccess]: (state, { payload: hotels }) => {
        return state.mergeIn(['hotels'], hotels);
    },
}, initialState);
